var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"not-found"}},[_c('Nav'),_c('h1',[_vm._v("404 - not found")]),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }